module.exports = __webpack_public_path__ + "img/WALK-SUPPORT-A-DROITE.505816ce.svg";